import { makeStyles } from "tss-react/mui";
import { MiDetailPageHeader } from "@miplatform/components";
import { mdiChevronLeft } from "@mdi/js";
import { Box } from "@mui/material";
import {
  USER_PROFILE_FORM_SECTIONS,
  UserProfile,
} from "../../components/UserProfile/UserProfile";
import { useSession } from "../../hooks";
import { LocalUserControls } from "./LocalUserControls";
import { useProfileViewModel } from "./useProfileViewModel";

export function Profile() {
  const { session } = useSession();

  const userId = session?.userId;

  const { classes } = useStyles();

  const {
    user,
    isLoading,
    handleUpdateUser,
    uploadProfilePhoto,
    deleteProfilePhoto,
    getProfilePhotoUrl,
  } = useProfileViewModel({ userId });

  return (
    <Box className={classes.contentContainer}>
      <MiDetailPageHeader
        title="Profile"
        titleIcon={mdiChevronLeft}
        loading={isLoading}
      />
      {process.env.BYPASS_AUTH && <LocalUserControls />}
      <UserProfile
        user={user}
        isLoading={isLoading}
        sections={[
          USER_PROFILE_FORM_SECTIONS.BASIC_INFO,
          USER_PROFILE_FORM_SECTIONS.CONTACT_INFO,
          USER_PROFILE_FORM_SECTIONS.PREFERENCES,
          USER_PROFILE_FORM_SECTIONS.USER_SETTINGS,
        ]}
        disableReadOnly
        handleUpdate={handleUpdateUser}
        uploadProfilePhoto={uploadProfilePhoto}
        deleteProfilePhoto={deleteProfilePhoto}
        getProfilePhotoUrl={getProfilePhotoUrl}
      />
    </Box>
  );
}

const useStyles = makeStyles()(() => ({
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "inherit",
  },
}));
